// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ingredient__image{display:block;height:calc(var(--win-height)/4);margin-bottom:var(--y-gutter-sm);position:relative}.ingredient__image .image .image__img{-o-object-position:bottom center;object-position:bottom center}.ingredient__category-image{height:32px;width:32px}.ingredient__title{font-weight:500;margin-bottom:1.5em}.ingredient__description{font-size:.9em;line-height:1.25}.ingredient--long .ingredient__description{line-height:1.375}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
